import { Card, CardContent, Chip, CircularProgress, Grid } from "@material-ui/core";
import * as React from "react";
import {
  Button,
  Create,
  RadioButtonGroupInput,
  SelectInput,
  TextInput,
  Toolbar,
  required,
  useNotify,
} from "react-admin";
import { ModuleTypeChoices } from "./Constant";
import TiptapRichTextInputField from "../../../Components/TiptapRichTextInput";
import { ModuleType } from "../../../Enums/ModuleType";
import { GetPbhStepType, GetRbhStepType, StepType } from "../../../Enums/StepType";
import InfoIcon from "@material-ui/icons/Info";
import { Form } from "react-final-form";
import { MailSchemaCreateModel } from "./MailSchemaCreateModel";
import { useAppDataProvider } from "../../../dataprovider";
import { useHistory } from "react-router-dom";
import { Add } from "@material-ui/icons";
import { useVerifyPermission } from "@airborne/react-admin";

const MailSchemaCreate = props => {
  useVerifyPermission("mailschemas", "create");
  const dataProvider = useAppDataProvider();
  const notify = useNotify();
  const [loading, setLoading] = React.useState(false);
  const history = useHistory();

  const [selectedModuleType, setSelectedModuleType] = React.useState<ModuleType>(ModuleType.Pbh);
  const [selectedText, setSelectedText] = React.useState<any>(
    GetPbhStepType.find(x => x.Value === StepType.OrderCreated)?.Description ?? null
  );

  //#region funct
  const moduleTypeOnChange = (form, e) => {
    setSelectedModuleType(e);
    form.change("schema", getStepTypes()[0].Value);
    getStepTypeDescription(getStepTypes()[0].Value);
  };

  const getStepTypeDescription = (stepType: StepType) => {
    let selectedText = getStepTypes().find(x => x.Value === stepType)?.Description ?? null;
    setSelectedText(selectedText);
  };

  const schemaOnChange = e => {
    let val = e.target.value;
    getStepTypeDescription(val);
  };

  const handleSubmit = async e => {
    let createModel: MailSchemaCreateModel = new MailSchemaCreateModel();
    createModel.StepType = e.schema;
    createModel.Body = e.body;
    createModel.Subject = e.subject;

    setLoading(true);
    dataProvider
      .postMailSchema(createModel)
      .then(result => {
        notify(`Record created`, "success", false, true);
        setLoading(false);
        history.push("/mailschemas/" + result?.data?.id);
      })
      .catch(result => {
        setLoading(false);
      });
  };

  const getStepTypes = () => {
    if (selectedModuleType === ModuleType.Pbh) {
      return GetPbhStepType;
    } else {
      return GetRbhStepType;
    }
  };
  //#endregion

  return (
    <Create title={"Mail Schema Create"} component="div" {...props}>
      <Form
        {...props}
        onSubmit={handleSubmit}
        render={({ handleSubmit, form }) => {
          return (
            <Card>
              <form>
                <CardContent>
                  <Grid container spacing={2}>
                    <RadioButtonGroupInput
                      source="moduleType"
                      label="Module Type"
                      fullWidth
                      defaultValue={ModuleType.Pbh}
                      onChange={e => moduleTypeOnChange(form, e)}
                      choices={ModuleTypeChoices}
                      validate={required()}
                      variant="outlined"
                    />
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                      <SelectInput
                        label="Schema"
                        source="schema"
                        choices={getStepTypes()}
                        optionText="Text"
                        optionValue="Value"
                        onChange={schemaOnChange}
                        defaultValue={GetPbhStepType[0]}
                        fullWidth
                        variant="outlined"
                        validate={required()}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={4}>
                      {selectedText && (
                        <Chip
                          size="medium"
                          style={{ color: "#767676" }}
                          variant="outlined"
                          label={selectedText}
                          icon={<InfoIcon />}
                        />
                      )}
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TextInput source="subject" label="Subject" validate={required()} fullWidth multiline />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                      <TiptapRichTextInputField source="body" validate={[required()]} />
                    </Grid>
                  </Grid>
                </CardContent>
                <Toolbar {...props} placeholder="">
                  <Button
                    label={loading ? "Mail schema is creating!" : "Create"}
                    disabled={loading}
                    size="medium"
                    variant="contained"
                    style={{ margin: "8px" }}
                    onClick={() => handleSubmit()}
                  >
                    {loading ? <CircularProgress size="2rem" color="secondary" /> : <Add />}
                  </Button>
                </Toolbar>
              </form>
            </Card>
          );
        }}
      />
    </Create>
  );
};

export default MailSchemaCreate;
